import React, {Component} from "react";
import {Calendar} from "antd";
import moment from "moment";
import Constants from "../../../services/Constants";

class PlanningCalendar extends Component {

  renderDay = date => {
    const {planning = {}} = this.props;
    const formattedDate = moment(date).format(Constants.DATE_FORMAT_API);

    const isFull = planning[formattedDate] && planning[formattedDate].bookedSlots >= planning[formattedDate].totalSlots;
    const color = planning[formattedDate] ? (isFull ? 'calendar-box--unavailable' : 'calendar-box--available') : 'calendar-box--closed';
    return (
      <div className={`${color} ant-fullcalendar-date`} style={{width: '100%', height: '8rem'}}>
        <div className="cell">
          <div className="corner tr">
            {moment(date).format("D")}
          </div>
          {planning[formattedDate] &&
            <div className="metric small">
              {planning[formattedDate].bookedSlots} / {planning[formattedDate].totalSlots}
            </div>
          }
        </div>
      </div>
    )
  };

  render() {
    const {selectedDay, onSelect} = this.props;
    return (
      <div style={{border: '1px solid #d9d9d9'}}>
        <Calendar className="calendar--hidden-year" fullscreen={true} value={moment(selectedDay)}
                  dateFullCellRender={this.renderDay}
                  onChange={date => onSelect(moment(date).format(Constants.DATE_FORMAT_API))}
        />
      </div>
    )
  }
}

export default PlanningCalendar;
